import { useTranslation } from 'react-i18next';
import React from 'react';
import { CustomStepWizardNavProps } from '../models/dashboard-models';

export const CustomStepWizardNav: React.FC<CustomStepWizardNavProps> = ({
    goToStep,
    currentStep,
    steps,
    setState,
    customContainerClass = '',
    isDisabled = false,
    translate = true,
}) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const hasSingleStep = steps.length === 1;

    return (
        <div className={`d-flex border-bottom justify-content-center mb-3 p-3 px-1 w-100 ${customContainerClass}`}>
            <div className='d-flex w-100 justify-content-between'>
                {steps.map((step, i) => (
                    <div
                        key={i}
                        role={hasSingleStep ? undefined : 'button'}
                        className={`d-flex justify-content-center ${hasSingleStep ? 'w-100 hover-none' : 'w-50'} step-nav-link ${isDisabled ? 'hover-none' : ''} text-center ${
                            currentStep === i + 1 ? 'active' : ''
                        }`}
                        onClick={!isDisabled && !hasSingleStep ? () => {
                            setState && setState(step);
                            goToStep!(i + 1);
                        } : () => {}}
                    >
                        <h5>{translate?t(step):step}</h5>
                    </div>
                ))}
            </div>
        </div>
    );
};
